import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AutofocusFixModule } from 'ngx-autofocus-fix';
// import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { TranslateModule, TranslateCompiler } from '@ngx-translate/core';

import { DatePipe } from '@angular/common';

import { LOCALE_ID } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApiErrorInterceptor } from './shared/services/api-error.interceptor';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { FlashComponent } from './shared/components/flash/flash.component';
import { WarningComponent } from './shared/components/warning/warning.component';

import { AppService } from './shared/services/app.service';
import { FlashService } from './shared/components/flash/services/flash.service';
import { ProgramService } from './programs/services/program.service';

import { AuthModule } from './auth/auth.module';
import { OffersModule } from './offers/offers.module';
import { SharedModule } from './shared/shared.module';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

// Factories

export function getLanguageFactory(appService: AppService) {
  return appService.getLanguage();
}

@NgModule({
  declarations: [
    AppComponent,
    FlashComponent,
    WarningComponent
  ],
  imports: [
    AuthModule,
    OffersModule,
    AppRoutingModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // NoopAnimationsModule,
    AutofocusFixModule.forRoot(),
    TranslateModule.forRoot({
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      }
    })
  ],
  providers: [
    AppService,
    FlashService,
    ProgramService,
    DatePipe,
    {
      provide: LOCALE_ID,
      deps: [ AppService ],
      useFactory: getLanguageFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor(
    private appService: AppService
  ) {
    this.appService.detectLanguage();
  }
}
